import React from 'react';
import { useModalsContext, useStoreConfigContext, useWishListsContext } from '/src/providers';
import { Modal, H2 } from '/src/components';
import * as styles from './styles.scss';

const DeleteWishList = ({
    wishlistId,
    name
}) => {
    const { translate } = useStoreConfigContext();
    const { hideModal, showModal, MODALS_TYPES } = useModalsContext();
    const { isLoadingWIshList, deleteWishList } = useWishListsContext();

    return (
        <Modal toggle={hideModal}>
            <div className={styles.modalWrapper}>
                <H2>{translate('Delete wishlist')}</H2>
                <span className={`${styles.notifyBold} ${styles.notify}`}>{translate('Are you sure you want to delete "%1"?', name)}</span>
                <span className={styles.notify}>{translate('This wishlist will be deleted immediately. You can\'t undo this action')}</span>
                <div className={styles.action}>
                    <button
                        className={`${styles.button} ${styles.accept}`}
                        onClick={
                            () => deleteWishList({
                                wishlistId: wishlistId,
                            })
                                .then(() => hideModal())
                                .catch(errors => showModal(MODALS_TYPES, {errors}))
                        }
                        disabled={isLoadingWIshList}
                    >
                        {translate('Delete')}
                    </button>
                    <button
                        className={`${styles.button} ${styles.reject}`}
                        onClick={hideModal}
                        disabled={isLoadingWIshList}
                    >
                        {translate('Cancel')}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteWishList;
